import {NgModule} from '@angular/core';
import {NavigationBarComponent} from './navigation-bar.component';

@NgModule({
  declarations: [
    NavigationBarComponent
  ],
  exports: [
    NavigationBarComponent
  ]
})
export class NavigationBarModule {

}
